<mat-form-field [hideRequiredMarker]="hideRequiredMarker" [floatLabel]=floatLabel [style.width]="inputWidth" style="display: flex;">
    <mat-label>{{label}}</mat-label>
    <mat-select [placeholder]="placeholder" [(ngModel)]="selected" [disabled]="disabled" (selectionChange)="onSelectChanged($event)" [multiple]="multiSelect" [panelClass]="panelClass">
        <mat-select-trigger *ngIf="customTrigger">
            <span>
                {{customTrigger}}
            </span>
          </mat-select-trigger>
        <mat-option *ngFor="let option of values" [disabled]="option.disabled" [value]="option.value" >{{option.displayName}}</mat-option>
    </mat-select>
</mat-form-field>
